<template>
    <div class="journalism-shell">
        <img class="imgs" src="@/assets/xinwen.png" alt=""/>
        <div class="news-list">
            <div class="news-box pointer" @click="$router.push('/detailss?article_id='+item.article_id)"
                 v-for="(item,index) in list" :key="index">
                <img :src="item.article_img" alt="" class="news-img">
                <div class="news-info">
                    <div class="news-title">{{item.article_title}}</div>
                    <div class="news-desc">{{item.article_content.replace(/<.*?>/g,'').substring(0,240)}}...</div>
                    <div class="news-time">{{item.add_time}}</div>
                </div>
            </div>
        </div>
        <div class="el-pagination">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-size="page_size"
                    background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'journalism',
    data () {
      return {
        pageIndex: 1,
        total: 0,
        list: [],
        page_size: 10
      }
    },
    mounted () {
      this.get_list()

    },
    methods: {
      get_list () {
        this.API.post('Home/article_out-get_article_list', {
          cate_id: 0,
          is_hot: 0, // 	热点聚焦 1
          is_suggest: 0, // 	精选推荐 1
          page_size: this.page_size,
          page: this.pageIndex
        }).then((res) => {
          this.list = res.data.article_list
          this.total = res.data.cont_article
        })
      },
      handleCurrentChange (val) { // 页数操作
        this.pageIndex = val
        this.get_list()
      },
    }
  }
</script>

<style lang="less" scoped>
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #2aa9b5 !important;
    }
    .journalism-shell {
        width: 100%;
        min-height: 100vh;
        background: #fff;
    }

    .imgs {
        width: 100%;
    }

    .news-list {
        padding-top: 80px;
        width: 1200px;
        margin: 0 auto;
        border: 1px solid #fff;

        .news-box {
            display: flex;
            align-items: flex-start;
            margin-bottom: 60px;

            .news-img {
                width: 326px;
                min-width: 326px;
                height: 190px;
                margin-right: 44px;
            }

            .news-info {
                .news-title {
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 20px;
                }

                .news-desc {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 26px;
                    line-height: 24px;
                }

                .news-time {
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }
            }
        }
    }

    .el-pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
    }
</style>
